import { useState } from 'react';

import { createArtist } from '@/actions/aloader';

import { useMutation } from '@tanstack/react-query';

import i18n from '@/i18n';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/joy';
import { useManager } from '@/hooks';

import { ArtistForm } from './[artistId]/edit';
import { Typography } from '@mui/joy'; 

export function CreateArtistPage() { 
    return (
        <CreateArtistContainer />
    )
}

export function CreateArtistContainer() {

    const manager = useManager()
    const [creating, setCreating] = useState(false)
    const [, setCreated] = useState(false)
    const [, setError] = useState(null)
    const navigate = useNavigate()

    const mutation = useMutation({
        mutationFn: (values) => createArtist(manager?.type, manager?.id, values),
        onError: (error) => {
            setError(error)
        },
        onMutate: () => {
            setCreating(true)
        },
        onSuccess: (node) => {
            setCreating(false)
            setCreated(true)
            navigate(`../${node.id}`)
        }
    })

    const handleSubmit = changeValues => {
        setCreating(true)
        setCreated(false)
        setError(null)
        mutation.mutate({
            ...changeValues
        })
    }
    if (manager) {
        return (
            <Container>
                <Typography level="h1">{i18n.t('add-artist')}</Typography>
                <ArtistForm
                    loading={creating}
                    onSubmit={handleSubmit}
                />
            </Container>
        );
    }
}

export default CreateArtistPage;